import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';
import stickykit from 'lib/pure-js-sticky-kit';

export default class StickyAdController extends Controller {
  connect() {
    this.initializeStickyAd();
  }

  disconnect() {
    triggerCustomEvent('StickyKit:detach', {}, this.element);
  }

  initializeStickyAd() {
    // If the main page content area is taller than the ad, then make the ad sticky.
    if (this.pageAreaTallerThanAd()) {
      stickykit(this.element, {
        parent: '.search-sidebar',
        // If you remove this it breaks the ad when sstk infinite results are loaded in
        spacer: '.sticky-ad-spacer',
        offsetTop: 130,
      });
    }
  }

  pageAreaTallerThanAd() {
    const adHeight = this.element.offsetHeight;
    const pageWrapper = document.querySelector('.ez-page-wrapper__content');
    const pageWrapperHeight = pageWrapper.offsetHeight - adHeight;

    return pageWrapperHeight > adHeight;
  }
}
